import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Divider,
  Stack,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import FilterCenterFocusOutlinedIcon from "@mui/icons-material/FilterCenterFocusOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import "./styles.css";

interface BenchmarkingUnlockDialogProps {
  open: boolean;
  onClose: () => void;
}

const BenchmarkUnlockDialog: React.FC<BenchmarkingUnlockDialogProps> = ({
  open,
  onClose,
}) => {
  const features = [
    {
      icon: <BarChartOutlinedIcon className="benchmark-item-icon" />,
      text: "Compare your performance against a customized peer set",
    },
    {
      icon: <FilterCenterFocusOutlinedIcon className="benchmark-item-icon" />,
      text: "Identify opportunities across every marketing channel",
    },
    {
      icon: <TrendingUpOutlinedIcon className="benchmark-item-icon" />,
      text: "Monitor trends with real-time industry context",
    },
    {
      icon: <VerifiedUserOutlinedIcon className="benchmark-item-icon" />,
      text: "Support marketing decisions with objective performance data",
      //   isLast: true,
    },
  ];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ className: "benchmark-dialog-paper" }}
    >
      <Box className="benchmark-header">
        <Box className="benchmark-lock-wrapper">
          <LockOutlinedIcon className="benchmark-lock-icon" />
        </Box>
        <Typography className="benchmark-title">
          Unlock Summit Benchmarking
        </Typography>
        <Typography className="benchmark-description">
          Benchmarking is part of the Summit Intelligence suite — giving you the
          context to understand not just how your marketing is performing, but
          how it compares to similar hotels.
        </Typography>
      </Box>

      <DialogContent className="benchmark-content">
        <Box className="benchmark-subhead-divider">
          <span>WITH BENCHMARKING YOU CAN</span>
        </Box>

        <Stack>
          {features.map((item, index) => (
            <React.Fragment key={index}>
              <Box className="benchmark-item">
                <Box className="benchmark-icon-container">{item.icon}</Box>
                <Typography className="benchmark-item-text">
                  {item.text}
                </Typography>
              </Box>
              {/* {!item.isLast &&  */}
              <Divider className="benchmark-item-divider" />
              {/*    }  */}
            </React.Fragment>
          ))}
        </Stack>

        <Box className="benchmark-footer">
          <Box className="benchmark-footer-line" />
          <Typography className="benchmark-footer-text">
            Contact your Client Success Manager to get started
          </Typography>
          <Box className="benchmark-footer-line" />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default BenchmarkUnlockDialog;
